import { Descriptions } from 'antd';
import { Accordion } from '../../../design-system/accordion';
import { KrTypes, useAppContext } from '../../../providers/AppContext';
import { useTheme } from '../../../providers/theme';
import { getColors } from '../../utils/getColors';

const SpecialCoreDescriptions = ({ data, title }) => {
  const { configStates } = useAppContext();
  const { isDay } = useTheme();
  const colors = getColors(isDay);
  const subtitle = {
    text: configStates.krType === KrTypes.WATER_OIL ? 'Water-Oil' : 'Gas-Oil',
    color:
      configStates.krType === KrTypes.WATER_OIL
        ? colors.waterOil
        : colors.gasOil
  };
  const children = (
    <Descriptions
      layout="vertical"
      column={5}
      className={
        isDay
          ? 'special-core-descriptions-day'
          : 'special-core-descriptions-night'
      }
    >
      {data.map((item, index) => (
        <Descriptions.Item
          key={item.label}
          label={
            <span
              style={{
                color: isDay ? colors.text : '#FAFBFF',
                paddingTop: '0.5rem',
                paddingLeft: '0.5rem'
              }}
            >
              {item.label}
            </span>
          }
          contentStyle={{
            fontWeight: 'bold',
            padding: '0.2rem 0.5rem 0.5rem'
          }}
        >
          {item.value}
        </Descriptions.Item>
      ))}
    </Descriptions>
  );
  return (
    <Accordion defaultOpen="kr-descriptions">
      <Accordion.Item
        id="kr-descriptions"
        header={
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', fontWeight: 'bold' }}>
            <span>{title}</span>
            <span style={{ color: subtitle.color }}>{subtitle.text}</span>
          </div>
        }
      >
        {children}
      </Accordion.Item>
    </Accordion>
  );
};

export default SpecialCoreDescriptions;
